export const DEFAULT_ERROR_MESSAGE =
  "Beim Abrufen der Daten ist etwas schiefgelaufen. Versuchen Sie es später erneut.";
